"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CustomForm_1 = __importStar(require("./CustomForm"));
var AlbinaForm = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.initialValues, initialValues = _b === void 0 ? {} : _b, elements = _a.elements, _c = _a.innerRowCustomClass, innerRowCustomClass = _c === void 0 ? "justify-content-evenly" : _c, _d = _a.confirmLabel, confirmLabel = _d === void 0 ? "Gönder" : _d, _e = _a.cancelLabel, cancelLabel = _e === void 0 ? "İptal" : _e, _f = _a.showConfirmButton, showConfirmButton = _f === void 0 ? true : _f, _g = _a.showCancelButton, showCancelButton = _g === void 0 ? false : _g, onSubmit = _a.onSubmit, onCancel = _a.onCancel, onValuesChange = _a.onValuesChange;
    var _h = (0, react_1.useState)(initialValues), formValues = _h[0], setFormValues = _h[1];
    // Form değerleri değiştikçe dışarıya bildiriyoruz.
    (0, react_1.useEffect)(function () {
        if (onValuesChange) {
            onValuesChange(formValues);
        }
    }, [formValues, onValuesChange]);
    var handleInputChange = function (id) { return function (e) {
        if (e instanceof Date || e === null) {
            setFormValues(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[id] = e, _a)));
            });
        }
        else if (e.target) {
            var _a = e.target, type_1 = _a.type, checked_1 = _a.checked, value_1 = _a.value;
            setFormValues(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[id] = type_1 === "checkbox" ? checked_1 : value_1, _a)));
            });
        }
        else {
            setFormValues(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[id] = e, _a)));
            });
        }
    }; };
    var enhancedElements = elements.map(function (element) {
        if (element.id && element.type === CustomForm_1.ElementType.SELECT) {
            return __assign(__assign({}, element), { value: formValues[element.id] || [], onChange: handleInputChange(element.id) });
        }
        else if (element.id) {
            return __assign(__assign({}, element), { value: formValues[element.id] || "", onChange: handleInputChange(element.id) });
        }
        return element;
    });
    var handleFormSubmit = function (values) {
        onSubmit(formValues);
    };
    // Ref üzerinden dışarıya sunulacak metod
    var getFormValues = function () { return formValues; };
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        getFormValues: getFormValues,
    }); });
    return (react_1.default.createElement(CustomForm_1.default, { elements: enhancedElements, innerRowCustomClass: innerRowCustomClass, confirmLabel: confirmLabel, cancelLabel: cancelLabel, showConfirmButton: showConfirmButton, showCancelButton: showCancelButton, onSubmit: handleFormSubmit, handleCancel: onCancel }));
});
exports.default = AlbinaForm;
